import { useState, useEffect } from "react";
import { useData } from "./DataContext.js";
import { style } from "./Style.js";

import { DragDropContext } from "react-beautiful-dnd";

import Card from "react-bootstrap/Card";

import DialoguePlacePicture from "./DialoguePlacePicture.js";
import DialogueCharPicture from "./DialogueCharPicture.js";
import DialogueTextCard from "./DialogueTextCard.js";

import ItemCollectionDroppable from "./ItemCollectionDroppable.js";

export default function DialogueModal (props)
{
    const gData = useData();
    
    // DRAG & DROP
    const [itemStruct, setItemStruct] = useState(null);

    useEffect(() => {
	if (gData.state.currentDialogue === null || gData.state.currentDialogue.interfaces.length === 0) setItemStruct(null);
	else {
	    const interfaces = gData.state.currentDialogue.interfaces[0];
	    const type = interfaces.params[0];
	    const charId = interfaces.params[1];
	    const labelRight = interfaces.params[2];
	    const labelWrong = interfaces.params[3];
	    const labelSkip = interfaces.params[4];
	    
	    const collectionIds = Object
		.values(gData.state.items)
		.filter((item) => {
		    const itemContent = gData.content.items[item.id];
		    return itemContent.themeId === gData.state.currentThemeId && itemContent.type === type && item.found;
		})
		.sort((item1, item2) => {
		    if (item1.found && item2.found) return item1.time - item2.time;
		    else if (item1.found) return -1;
		    else if (item2.found) return +1;
		    else return 0;
		})
		.map((item) => item.id);

	    const selectionIds = [null, null];

	    setItemStruct({
		type,
		charId,
		labelRight,
		labelWrong,
		labelSkip,
		collectionIds,
		selectionIds
	    });
	}
    }, [gData.state.currentDialogue, gData.state.currentThemeId, gData.state.items, gData.content,]);
    
    const onDragEnd = (result) => {
	const { destination, source, draggableId } = result;
	if (! destination) return;
	if (destination.droppableId === source.droppableId && destination.index === source.index) return;

	const newItemStruct = { ...itemStruct };

	if (source.droppableId === "itemCollection")
	{
	    const collectionIds = [ ...newItemStruct.collectionIds ];
	    collectionIds.splice(source.index, 1);
	    newItemStruct.collectionIds = collectionIds;
	}
	
	else if (source.droppableId.startsWith("itemSelection"))
	{
	    const num = Number(source.droppableId.substring(13));
	    newItemStruct.selectionIds[num] = null;
	}

	if (destination.droppableId === "itemCollection")
	{
	    const collectionIds = [ ...newItemStruct.collectionIds ];
	    collectionIds.splice(destination.index, 0, draggableId);
	    newItemStruct.collectionIds = collectionIds;
	}
	
	else if (destination.droppableId.startsWith("itemSelection"))
	{
	    const num = Number(destination.droppableId.substring(13));
	    if (newItemStruct.selectionIds[num] !== null)
	    {
		const collectionIds = [ ...newItemStruct.collectionIds ];
		collectionIds.splice(collectionIds.length, 0, newItemStruct.selectionIds[num]);
		newItemStruct.collectionIds = collectionIds;
	    }
	    newItemStruct.selectionIds[num] = draggableId;
	}

	setItemStruct(newItemStruct);
    };

    let itemCollectionDroppable = null;
    if (gData.state.currentDialogue !== null && gData.state.currentDialogue.interfaces.length > 0 && itemStruct !== null)
    {
	itemCollectionDroppable = (<ItemCollectionDroppable itemStruct={itemStruct}/>);
    }

    {/* <div className="position-absolute bottom-0 start-0 my-3 vw-100">
	<Card className="m-auto shadow border-2 border-secondary" style={{ width: "90%" }}>
	<Card.Body>
	{itemStruct.type === "info" && (<span className="fs-4 text-uppercase"><span className="fw-bold">Informations</span> collectées</span>)}
	{itemStruct.type === "bp" && (<span className="fs-4 text-uppercase"><span className="fw-bold">Conseils</span> collectés</span>)}
	{itemCollectionDroppable}
	</Card.Body>
	</Card>
	</div> */}

    return (
	<>
	    <DialoguePlacePicture/>
	    <DialogueCharPicture/>
	    <DragDropContext onDragEnd={onDragEnd}>
		<DialogueTextCard itemStruct={itemStruct}/>
		{(itemStruct !== null && gData.state.showModals.dialogue && gData.state.currentDialogue.interfaces.length > 0) && (
		    <div className="position-absolute mx-4" style={{ ...style.modal.interface.style }}>
			<Card className="shadow border-2 border-secondary">
			    <Card.Body>
				{itemStruct.type === "info" && (<span className="fs-4 text-uppercase"><span className="fw-bold">Informations</span> collectées</span>)}
				{itemStruct.type === "bp" && (<span className="fs-4 text-uppercase"><span className="fw-bold">Conseils</span> collectés</span>)}
				{itemCollectionDroppable}
			    </Card.Body>
			</Card>
		    </div>
		)}
	    </DragDropContext>
	</>
    );
}






